const backgroundColor = '#faf9f7';
const textColor = '#2c1810';
const iconButtonColor = '#737271';
const blueColor = '#2453ff';
const lightBlueColor = '#7a9fff';
export const designUtils = {
  backgroundColor,
  textColor,
  iconButtonColor,
  blueColor,
  lightBlueColor,
};

const AverageAmountByDateChartPadding = {
  top: 10,
  right: 20,
  bottom: 30,
  left: 40,
};
const AverageAmountByDateChartWidth = 300;
const AverageAmountByDateChartHeight = 200;

export const averageAmountByDateChartUtils = {
  padding: AverageAmountByDateChartPadding,
  width: AverageAmountByDateChartWidth,
  height: AverageAmountByDateChartHeight,
};
